import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RevenueReportState, SetRevenueReportsPayload, SetRevenueReportPayload, SetRevenueReportFiltersPayload } from "./index";
import { config } from "config";

const default_page_size = config.PAGE_SIZE;

const initialState: RevenueReportState = {
    revenueReports: [],
    revenueReport: null,
    loading: false,
    refresh: 0,
    refreshLoader: false,
    current_filters: {},
    filters: { page: 1, page_size: default_page_size },
};

export const revenueReportSlice = createSlice({
    name: "revenueReport",
    initialState,
    reducers: {
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload;
        },
        setRevenueReports: (state, action: PayloadAction<SetRevenueReportsPayload>) => {
            state.revenueReports = action.payload;
            state.refreshLoader = false;
        },
        setRevenueReport: (state, action: PayloadAction<SetRevenueReportPayload>) => {
            state.revenueReport = action.payload.report;
        },
        refresh: (state) => {
            state.refresh += 1;
            state.refreshLoader = true;
        },
        resetPage: (state) => {
            state.filters.page = 1;
        },
        setRevenueReportFilters: (state, action: PayloadAction<SetRevenueReportFiltersPayload>) => {
            state.filters = action.payload.data;
            state.refreshLoader = true;
        },
        setCurrentRevenueReportFilters: (state, action: PayloadAction<SetRevenueReportFiltersPayload>) => {
            state.current_filters = action.payload.data;
        },
        resetFilters: (state) => {
            state.refresh += 1;
            state.refreshLoader = true;
            state.filters = initialState.filters;
            state.current_filters = initialState.current_filters;
        },
    }
});

export const revenueReportActions = revenueReportSlice.actions;
export default revenueReportSlice.reducer; 